module.exports = __webpack_public_path__ + "img/code_app.9d0d4f9e.png";